<script>
import vSelect from 'vue-select'
import debounce from 'lodash/debounce';

export default {
    name: "RootQuickAccess",
    components: {vSelect},
    data: function () {
        return {
            options: [],
            rent: true,
            selected_type: null,
            error: false,
        }
    },
    methods: {
        find() {
            if (this.selected_type) {
                 window.location =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                    (this.rent ? this.selected_type.url_rent_general : this.selected_type.url_sale_general) ;

            } else {
                this.error = true;
            }

        },
        order() {

            if (this.selected_type) {
                 window.location =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  '/service-request/' + (this.rent ? 'rent' : 'sale') + '/' +
                    (this.selected_type.id ?? this.selected_type.id) ;

            } else {
                this.error = true;
            }

        },
        onSearch(search, loading) {
            if (search.length) {

                loading(true);
                this.search(loading, search, this);

            }
        },
        search: debounce((loading, search, vm) => {

            axios.get('/api/type/search/' + search).then(response => {
                vm.options = response.data.result

                loading(false);
            });

            // fetch(
            //   `https://api.github.com/search/repositories?q=${escape(search)}`
            // ).then(res => {
            //   res.json().then(json => (vm.options = json.items));
            //   loading(false);
            // });
            //

        }, 1000)
    }
}
</script>


<style scoped>

</style>
